const CodeLookup = (customParams)=>{
    return {
        valueExpr: 'Code',
        displayExpr: 'Code',
        sort: [{ selector: "Code", desc: false }],
        searchEnbabled: true,
        acceptCustomValue: true,
        gridKey: '7E50C98A-CE71-4523-A39F-0CCE740EA72A',
        params: {
            module: "SP",
            lookupType: "ServicePricing",
            showLookupGrid: true,
            isPascalCase: true,
            ...customParams
        },
        columns:  [
            { dataField: "Code", caption: "Code", dataType: "string" },
            { dataField: "Description1", caption: "Description - 1", dataType: "string" },
            { dataField: "Description2", caption: "Description - 2", dataType: "string" },
        ]
    }
}

export {
CodeLookup
}